// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Belt_Array from "../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as CountryContext from "../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as BlacklistPartnerForm from "./partner-blacklist/BlacklistPartnerForm.bs.js";
import * as TrustAndSafetySidebar from "./TrustAndSafetySidebar.bs.js";
import * as ToastSnackbarHook$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/hooks/toast-notification/ToastSnackbarHook.bs.js";
import * as BlacklistPartnerDataMachine from "../../app/partner-blacklist/data-machine/BlacklistPartnerDataMachine.bs.js";
import * as TrustAndSafetyAssetsManager from "../assets/TrustAndSafetyAssetsManager.bs.js";

TrustAndSafetyAssetsManager.importCss(undefined);

var layersIcon = TrustAndSafetyAssetsManager.getImage("layers-icon.svg");

function TrustAndSafetyContainer(Props) {
  var initialFeature = Props.initialFeature;
  var prefill = Props.prefill;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = ToastSnackbarHook$Catalyst.useSnackbar(5000, undefined, undefined);
  var openSnackbar = match$1[1];
  var match$2 = React.useState(function () {
        return Belt_Option.getWithDefault(prefill.partnerId, "");
      });
  var setPartnerId = match$2[1];
  var partnerId = match$2[0];
  var match$3 = React.useState(function () {
        
      });
  var setFraudType = match$3[1];
  var fraudType = match$3[0];
  var match$4 = React.useState(function () {
        return [/* Documents */0];
      });
  var setBlacklistTypes = match$4[1];
  var blacklistTypes = match$4[0];
  var match$5 = React.useState(function () {
        return "";
      });
  var setComment = match$5[1];
  var comment = match$5[0];
  var match$6 = React.useState(function () {
        return /* Idle */0;
      });
  var setStatus = match$6[1];
  var status = match$6[0];
  var isSubmitting = typeof status === "number" ? status !== 0 : false;
  var validationErrors = React.useMemo((function () {
          var errors = /* [] */0;
          if (partnerId.trim().length === 0) {
            errors = {
              hd: "Partner ID",
              tl: errors
            };
          }
          if (Belt_Option.isNone(fraudType)) {
            errors = {
              hd: "Fraud Type",
              tl: errors
            };
          }
          if (blacklistTypes.length === 0) {
            errors = {
              hd: "Blacklist Type",
              tl: errors
            };
          }
          return Belt_List.reverse(errors);
        }), [
        partnerId,
        fraudType,
        blacklistTypes
      ]);
  var handleSubmit = function ($$event) {
    $$event.preventDefault();
    var isFormValid = List.length(validationErrors) === 0;
    if (!isFormValid) {
      return ;
    }
    if (fraudType === undefined) {
      return ;
    }
    Curry._1(setStatus, (function (param) {
            return /* Submitting */1;
          }));
    var trimmedComment = comment.trim();
    var partnerIdFloat = Number(partnerId.trim());
    var payload_comment = trimmedComment.length !== 0 ? trimmedComment : undefined;
    var payload = {
      partnerId: partnerIdFloat,
      fraudType: fraudType,
      blacklistTypes: blacklistTypes,
      comment: payload_comment
    };
    return BlacklistPartnerDataMachine.blacklistPartner(payload, (function (response) {
                  Curry._1(openSnackbar, {
                        TAG: /* Success */0,
                        _0: response.message
                      });
                  Curry._1(setPartnerId, (function (param) {
                          return "";
                        }));
                  Curry._1(setFraudType, (function (param) {
                          
                        }));
                  Curry._1(setBlacklistTypes, (function (param) {
                          return [/* Documents */0];
                        }));
                  Curry._1(setComment, (function (param) {
                          return "";
                        }));
                  return Curry._1(setStatus, (function (param) {
                                return /* Idle */0;
                              }));
                }), (function (error) {
                  Curry._1(openSnackbar, {
                        TAG: /* Error */1,
                        _0: ErrorUtils$Catalyst.resolveError(error)
                      });
                  return Curry._1(setStatus, (function (param) {
                                return /* Idle */0;
                              }));
                }), country);
  };
  var tmp;
  switch (initialFeature) {
    case /* BulkSuspensions */0 :
        tmp = React.createElement("div", {
              className: "c-blacklist-partner-page__placeholder"
            }, React.createElement("h2", undefined, "Bulk Suspensions"), React.createElement("p", undefined, "Coming soon..."));
        break;
    case /* PartnerBlacklist */1 :
        tmp = React.createElement(BlacklistPartnerForm.make, {
              partnerId: partnerId,
              fraudType: fraudType,
              blacklistTypes: blacklistTypes,
              comment: comment,
              onPartnerIdChange: (function (value) {
                  return Curry._1(setPartnerId, (function (param) {
                                return value;
                              }));
                }),
              onFraudTypeChange: (function (value) {
                  return Curry._1(setFraudType, (function (param) {
                                return value;
                              }));
                }),
              onBlacklistTypeToggle: (function (bt) {
                  return Curry._1(setBlacklistTypes, (function (prev) {
                                if (Belt_Array.some(prev, (function (t) {
                                          return t === bt;
                                        }))) {
                                  return Belt_Array.keep(prev, (function (t) {
                                                return t !== bt;
                                              }));
                                } else {
                                  return Belt_Array.concat(prev, [bt]);
                                }
                              }));
                }),
              onCommentChange: (function (value) {
                  return Curry._1(setComment, (function (param) {
                                return value;
                              }));
                }),
              onSubmit: handleSubmit,
              isSubmitting: isSubmitting,
              validationErrors: validationErrors
            });
        break;
    case /* WalletWithdrawalBlock */2 :
        tmp = React.createElement("div", {
              className: "c-blacklist-partner-page__placeholder"
            }, React.createElement("h2", undefined, "Wallet Withdrawal Block/Unblock"), React.createElement("p", undefined, "Coming soon..."));
        break;
    
  }
  return React.createElement("div", {
              className: "c-blacklist-partner-page"
            }, React.createElement("div", {
                  className: "c-blacklist-partner-page__header"
                }, React.createElement("div", {
                      className: "c-blacklist-partner-page__header-title"
                    }, React.createElement("img", {
                          alt: "",
                          src: layersIcon
                        }), React.createElement("span", undefined, "Trust & Safety / Manual Actions")), React.createElement("div", {
                      className: "c-blacklist-partner-page__badge"
                    }, "INTERNAL TOOL")), React.createElement("div", {
                  className: "c-blacklist-partner-page__container"
                }, React.createElement(TrustAndSafetySidebar.make, {
                      activeFeature: initialFeature
                    }), React.createElement("div", {
                      className: "c-blacklist-partner-page__content"
                    }, tmp)), match$1[0]);
}

var make = TrustAndSafetyContainer;

export {
  layersIcon ,
  make ,
  
}
/*  Not a pure module */
